import React from 'react'
import {NavLink} from "react-router-dom";
import './admin-header.css'

const GROUPS = [
    {
        label: 'Wind Diagnostics',
        links: [
            {to: '/admin', label: 'User handling', end: true},
            {to: '/admin/data', label: 'Data'},
        ],
    },
    {
        label: 'Lightning',
        links: [
            {to: '/admin/lightning', label: 'User subscription', end: true},
            {to: '/admin/lightning/data', label: 'Data'},
        ],
    },
]

export default function AdminHeader() {
    return (<nav className='admin-header'>
        {GROUPS.map(group => (
            <div className='admin-nav-group' key={group.label}>
                <span className='admin-nav-group-label'>{group.label}</span>
                {group.links.map(link => (
                    <NavLink key={link.to}
                             to={link.to}
                             end={link.end}
                             className={({isActive}) => `admin-nav-link ${isActive ? 'active' : ''}`}>
                        {link.label}
                    </NavLink>
                ))}
            </div>
        ))}
    </nav>)
}
